$(document).ready(function () {
    // Video Modal Functionality
    $('.play-watch').on('click', function() {
        const videoId = $(this).data('video-id');
        const modal = $('#' + videoId);
        const video = modal.find('video')[0];
        
        modal.fadeIn(300);
        if (video) {
            video.play();
        }
        $('body').css('overflow', 'hidden');
    });

    $('.video-modal-close, .video-modal-overlay').on('click', function() {
        const modal = $(this).closest('.video-modal');
        const video = modal.find('video')[0];
        
        if (video) {
            video.pause();
            video.currentTime = 0;
        }
        modal.fadeOut(300);
        $('body').css('overflow', '');
    });

    // Close modal on ESC key
    $(document).on('keydown', function(e) {
        if (e.key === 'Escape') {
            $('.video-modal:visible').each(function() {
                const video = $(this).find('video')[0];
                if (video) {
                    video.pause();
                    video.currentTime = 0;
                }
                $(this).fadeOut(300);
            });
            $('body').css('overflow', '');
        }
    });

    $('.watch-slider-row').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        prevArrow: '<button type="button" class="slick-prev"><svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path></svg></button>',
        nextArrow: '<button type="button" class="slick-next"><svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path></svg></button>',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    });

    $('.benefit-row').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        prevArrow: '<button type="button" class="slick-prev"><svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path></svg></button>',
        nextArrow: '<button type="button" class="slick-next"><svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path></svg></button>',
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    });
});